var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcInTransit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8485 5.3648L9.69187 2.04413C8.77654 1.31613 7.49654 1.31546 6.5772 2.04546L2.45053 5.3568C1.94586 5.73946 1.65186 6.32013 1.64453 6.95546V14.0021C1.64453 14.2781 1.86853 14.5021 2.14453 14.5021C2.42053 14.5021 2.64453 14.2781 2.64453 14.0021V6.9608C2.64786 6.6428 2.79786 6.3488 3.06586 6.14546L7.2012 2.8268C7.7512 2.3908 8.51987 2.38946 9.06854 2.82613L13.2385 6.15613C13.4879 6.34213 13.6399 6.64346 13.6439 6.95546V14.0021C13.6439 14.2781 13.8679 14.5021 14.1439 14.5021C14.4199 14.5021 14.6439 14.2781 14.6439 14.0021V6.94813C14.6345 6.31946 14.3325 5.72413 13.8485 5.3648Z",
    fill: "#DCB900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.4184 10.6311C9.4184 10.9111 9.19173 11.1311 8.9184 11.1311H7.37173C7.0984 11.1311 6.87173 10.9111 6.87173 10.6311C6.87173 10.3578 7.0984 10.1311 7.37173 10.1311H8.9184C9.19173 10.1311 9.4184 10.3578 9.4184 10.6311ZM9.4584 8.06445H6.83173C5.75839 8.06445 5.01172 8.84445 5.01172 9.95779V12.4311C5.01172 13.5511 5.75839 14.3311 6.83173 14.3311H9.4584C10.5317 14.3311 11.2784 13.5511 11.2784 12.4311V9.95779C11.2784 8.84445 10.5317 8.06445 9.4584 8.06445Z",
    fill: "#DCB900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInTransit);
export default __webpack_public_path__ + "static/media/ic-in-transit.719829800b4c8793e15a973fe34caa5b.svg";
export { ForwardRef as ReactComponent };